import Icon from "@components/Atoms/Icon";
import SpinnerLoader from "@components/Atoms/SpinnerLoader";
import t from "@ext/localization/locale/translate";
import { ConfirmMenuItem, type ConfirmOptions } from "@ui-kit/ConfirmPopover";

export type DeleteItemProps = {
	buttonText?: string;
	isLoading?: boolean;
	confirm?: ConfirmOptions | (() => ConfirmOptions | null);
	onConfirm: () => unknown;
};

const DeleteItem = ({ buttonText = t("delete"), isLoading, confirm, onConfirm }: DeleteItemProps) => (
	<ConfirmMenuItem confirm={confirm} onConfirm={onConfirm} type="danger">
		{isLoading ? <SpinnerLoader height={14} width={14} /> : <Icon code="trash" />}
		{buttonText}
	</ConfirmMenuItem>
);

export default DeleteItem;
